import { useQuery } from '@tanstack/react-query'
import type { ExportJobStatusResponseDto } from '@trellis/api'

import { getReceiptBundleJob } from '@/requests/reports'

const EXPORT_JOB_POLL_INTERVAL_MS = 3000

const TERMINAL_EXPORT_JOB_STATUSES = new Set<ExportJobStatusResponseDto['status']>([
  'READY',
  'FAILED',
])

/**
 * Polls an export job (receipt bundle, or EOFY pack with receipts included) until it
 * reaches a terminal status. Pass `null` before a job exists — the query stays disabled
 * and no request is made.
 */
export function useExportJob(jobId: string | null) {
  return useQuery({
    queryKey: ['export-job', jobId],
    queryFn: () => getReceiptBundleJob(jobId!),
    enabled: jobId !== null,
    refetchInterval: (query) => {
      const status = query.state.data?.data?.status
      return status && TERMINAL_EXPORT_JOB_STATUSES.has(status)
        ? false
        : EXPORT_JOB_POLL_INTERVAL_MS
    },
  })
}
